import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';



import { getStandardDetailsService } from 'src/standard/infrastructure/getters';
import { InputGroup } from 'src/user/components/layout/input-group/input-group';



import { JustificationContainer, JustificationLinkContainer, LinkStyles } from 'src/standard/components/single-standard/tabs-sections/single-standard-page-section/page-blocks/justification/justification-components.styled';
import { StandardDisplayField, StandardDisplayFieldHeader, StandardDisplayFieldValueAbsent, StandardReference } from 'src/standard/components/single-standard/tabs-sections/single-standard-page-section/single-standard.styled';


export default function StandardViewBlockReference() {

	const { t } = useTranslation();
	const standardDetailsService = getStandardDetailsService();
	const consideredStandards = standardDetailsService.standard?.justification.consideredStandards ?? [];

	const renderStandards = () =>
		consideredStandards.map((standard, index) => (
			<div key={`${standard.id}-${standard.name}`}>
				<Link target="_blank" style={LinkStyles} to={`/standards/detailed/${standard.id}/general`}>
					{standard.name}
				</Link>
				{index !== consideredStandards.length - 1
					? ','
					: null}
			</div>
		));

	return (
		<InputGroup title={t('standard.singleStandardPage.reference.title')}>
			<JustificationContainer>
				<StandardDisplayField>

					<StandardDisplayField>
						<StandardDisplayFieldHeader>
							{t('standard.singleStandardPage.justification.otherStandardsInASD')}
						</StandardDisplayFieldHeader>
						<JustificationLinkContainer>
							{consideredStandards.length > 0 ? (
								renderStandards()
							) : (
								<StandardDisplayFieldValueAbsent>
									{t('standard.singleStandardPage.justification.otherStandardsOutsideASDAbsent')}
								</StandardDisplayFieldValueAbsent>
							)}
						</JustificationLinkContainer>
					</StandardDisplayField>
				</StandardDisplayField>


				<StandardDisplayField>
					<StandardDisplayFieldHeader>
						{t('standard.singleStandardPage.justification.otherStandardsOutsideASD')}
					</StandardDisplayFieldHeader>
					<JustificationLinkContainer>
						{ standardDetailsService.standard?.justification.externalConsideredStandards ? (
							<StandardReference
								dangerouslySetInnerHTML={{ __html: standardDetailsService.standard.justification.externalConsideredStandards }}
							/>
						) : (
							<StandardDisplayFieldValueAbsent>
								{t('standard.singleStandardPage.justification.otherStandardsInASDAbsent')}
							</StandardDisplayFieldValueAbsent>
						)}
					</JustificationLinkContainer>
				</StandardDisplayField>

			</JustificationContainer>
		</InputGroup>
	)
}
